import { render, staticRenderFns } from "./TransactionTest.vue?vue&type=template&id=6ec90676&scoped=true"
import script from "./TransactionTest.vue?vue&type=script&lang=js"
export * from "./TransactionTest.vue?vue&type=script&lang=js"
import style0 from "./TransactionTest.vue?vue&type=style&index=0&id=6ec90676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec90676",
  null
  
)

export default component.exports